/** What an old /agents/kickoff or /agents/media-plans link shows: straight on to the BO, or a button when framed. */
import { useEffect } from 'react';
import { ExternalLink } from 'lucide-react';
import { backOfficeUrlForClient, openInBackOffice } from './backOffice';

export function MovedToBackOffice({ what, path }: { what: string; path: string }) {
  const framed = typeof window !== 'undefined' && window.top !== window;
  // Not framed: go straight on. Framed (inside the BO), leaving needs the user's click.
  useEffect(() => { if (!framed) window.location.replace(backOfficeUrlForClient(path)); }, [framed, path]);
  return (
    <div className="mx-auto mt-16 max-w-md rounded-2xl border border-[#eaecf0] bg-white p-6 text-center">
      <h1 className="text-[18px] font-semibold text-[#101828]">{what} moved to the back office</h1>
      <p className="mt-2 text-[13px] text-[#667085]">It lives in the back office now, together with Kickoff and the Oneflow agreement.</p>
      <button type="button" onClick={() => openInBackOffice(path)} className="mt-4 inline-flex items-center gap-1.5 rounded-lg bg-[#101828] px-4 py-2 text-[13px] font-semibold text-white">
        Open in the back office <ExternalLink className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
